import { render, staticRenderFns } from "./overseas_user.vue?vue&type=template&id=43595434&scoped=true&"
import script from "./overseas_user.vue?vue&type=script&lang=js&"
export * from "./overseas_user.vue?vue&type=script&lang=js&"
import style0 from "./overseas_user.vue?vue&type=style&index=0&id=43595434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43595434",
  null
  
)

export default component.exports